






















































































































import { Watch, Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import _, { property } from 'lodash';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Users from '@/store/modules/Users';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import BasicInputForm from '@/components/forms/BasicInputForm.vue';
import Viewpoints from '@/store/modules/Viewpoints';
import Decisions from '@/store/modules/Decisions';
import { Viewpoint } from '@/api/model/Viewpoint';
import { NotificationEventBus } from '@/EventBus';
import Choices, { Choice } from '@/store/modules/Choices';
import ViewpointVisibilityDialog from '@/components/workspace-options/ViewpointVisibilityDialog.vue';
import { Urls } from '@/Urls';
import ChoiceInputDialog from '@/components/choice-input/ChoiceInputDialog.vue'

const usersModule = getModule(Users);
const decisionsModule = getModule(Decisions);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);

@Component({
    components: {
        ConfirmationDialog,
        ViewpointVisibilityDialog,
        BasicInputForm,
        ChoiceInputDialog
    },
    directives: {},
})
export default class ChoiceViewpointScorerMenu extends Vue {
    @Prop({
        default: () => {
            return {};
        },
        type: Object,
    })
    item!: any;

    @Prop({default:false,type: Boolean})
    noCreateBtn!: boolean;

    @Prop({default: true, type: Boolean})
    addToList!: boolean;

    private cloneChoiceDialog = false;
    private originalChoice: any = {};
    private menuShow: boolean = false;
    private createViewpointDialog = false;
    private adding = false;

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get activeChoiceLists() {
        return workspaceOptionsModule.activeChoiceLists || [];
    }

    get choiceIds() {
        return choicesModule.choiceIds;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get activeViewpointList() {
        return workspaceOptionsModule.activeViewpointLists;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    private async createViewpoint(viewpoint: any) {
        if (!this.selectedDecision) return;
        this.adding = true;
        let sampleViewpoint = _.cloneDeep(viewpoint);
        NotificationEventBus.emitProcessingMessage();
        this.createViewpointDialog = false;
        try {
            let res = await decisionsModule.createDecisionViewpoint({
                decisionId: this.selectedDecision.decisionId,
                name: viewpoint.name,
                description: viewpoint.description
            });
            if (
                sampleViewpoint.addToList &&
                this.activeViewpointList?.length > 0 &&
                this.addToList
            ) {
                decisionsModule.addViewpointToActiveLists(res.viewpointId);
            }
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
        this.adding = false;
    }

    private async copyChoice(choice: any) {
        this.cloneChoiceDialog = false;
        await choicesModule.copyChoice({ choice: this.originalChoice, newChoiceParams: choice });
    }

    private async deleteChoice(choiceId: string) {
        NotificationEventBus.emitProcessingMessage();
        try {
            await choicesModule.deleteChoice(choiceId);
            if (this.choiceIds && this.choiceIds.length > 0) {
                for (let item of this.choiceIds) {
                    if (item !== choiceId) {
                        choicesModule.selectChoice(item);
                        break;
                    }
                }
            }
            this.menuShow = false;
            NotificationEventBus.emitSuccessMessage();
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e);
        }
    }

    private canUserDelete(choice: any) {
        let usersModule = getModule(Users);

        //Owner of decision can always delete choices
        if (
            decisionsModule.selectedDecision.ownerUserId === usersModule.currentUserProfile.userId
        ) {
            return true;
        }

        if (choice.ownerUserId === usersModule.currentUserProfile.userId) {
            return true;
        }

        //Reaching here means user is not owner of choice or decision
        return !['VIEW', 'EDIT'].includes(choice.shareSetting);
    }
}
